import { defineComponent as b, ref as p, provide as n, computed as l, openBlock as x, createElementBlock as w, normalizeClass as o, createElementVNode as r, renderSlot as h, normalizeStyle as T, unref as y } from "vue";
import { usePositionedStyle as C } from "../../composables/usePositionedStyle.js";
import { tw as e } from "../../utils/tailwind.js";
import { setActiveTabKey as _, variantKey as E } from "./Tabs.constant.js";
const N = ["aria-label"], S = 4, W = /* @__PURE__ */ b({
  name: "RevTabs",
  __name: "Tabs",
  props: {
    label: {},
    variant: { default: "fixed" }
  },
  setup(s) {
    const t = s, f = {
      left: "0px",
      width: "0px"
    }, i = p(), { style: d } = C({
      callback: (a) => ({
        left: `${a.parentElement.offsetLeft - S}px`,
        width: `${a.parentElement.offsetWidth}px`
      }),
      defaultStyle: f,
      elementRef: i
    });
    n(_, (a) => {
      a && (i.value = a);
    }), n(E, t.variant);
    const c = l(() => [
      e`relative -mx-4 px-4`,
      t.variant === "flexible" && e`max-w-full overflow-x-auto`
    ]), m = l(() => [
      e`-mx-4 flex max-w-full list-none px-4`,
      t.variant === "fixed" && e`w-full overflow-x-hidden`,
      t.variant === "flexible" && e`gap-32`
    ]), u = l(() => [
      t.variant === "fixed" && e`max-w-full`,
      t.variant === "flexible" && e`w-max after:border-static-default-low after:absolute after:inset-x-4 after:bottom-8 after:-mt-1 after:border-t after:content-['']`
    ]), v = l(() => [
      e`border-static-default-low relative h-2 max-w-full border-b`,
      t.variant === "flexible" && e`mb-8`
    ]);
    return (a, L) => (x(), w("nav", {
      "aria-label": s.label,
      class: o(c.value)
    }, [
      r("div", {
        class: o(u.value)
      }, [
        r("div", {
          class: o(m.value),
          role: "tablist"
        }, [
          h(a.$slots, "default")
        ], 2),
        r("div", {
          "aria-hidden": "",
          class: o(v.value)
        }, [
          r("div", {
            class: "border-action-default-low-pressed absolute left-0 top-0 z-10 border-t-2 ease-in-out motion-safe:transition-all motion-safe:duration-200",
            style: T(y(d))
          }, null, 4)
        ], 2)
      ], 2)
    ], 10, N));
  }
});
export {
  W as default
};
